module.exports = __webpack_public_path__ + "static/3_years_side_by_side-82155003129011db0139ff85f9f0fbcb.png";